import '../style.scss'
import { useContext, useEffect, useState } from "react";
import { 
    AppSpan, AppText, Button, CenterPopupContainer,
    CustomContainer, FixedContainer, FlexRow, ScreenTitle 
} from "src/style"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service';
import { NewUserLayout } from 'src/component'
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { UserType } from 'src/model';

export const NewUserSetupSummary: React.FC<any> = ({next, back, selectedUser, fetchUpdatedUsers, close}) => {
    const {API} = useContext(ApiContext)
    const {info: {userCreationProcess, userType}, setInfoProperty} = useContext(AppInfoContext)
    const [currentUserType, setCurrentUserType] = useState(userType)
    const [hidePassword, setHidePassword] = useState(true)

    useEffect(() => {
        if (userType) setCurrentUserType(userType)
    }, [userType]) 

    async function handleNext() {
        await setInfoProperty('userCreationProcess', {...userCreationProcess, setupSummary: true})
        
        let response; 
        const { firstName, lastName, email, city, password, permission, phoneNumber, roleType } = userCreationProcess
        const payload = {
            firstName, lastName, email,
            city, password, phoneNumber,
            roleType,
            ...(currentUserType === UserType.ADMIN ? { permissions: [permission] } : { permission })
        }

        if (currentUserType != UserType.ADMIN) {
            response = !selectedUser ? 
            await API.createOrganizationStaff({...payload})
            : await API.updateOrganizationStaff({...payload}, selectedUser.id)
        }
        else {
            response = !selectedUser ? 
            await API.createAdminStaff({...payload})
            : await API.updateAdminStaff({...payload}, selectedUser.id)
        }
        
        if (response) {
            await fetchUpdatedUsers()
            next()
        }
    }

    return (
        <>
            <CenterPopupContainer onClick={close} />
            <FixedContainer
                top="50" tSizeUnit="%" 
                left="50" lSizeUnit="%"
                bgColor="#ffffff" zIndex='9'
                height='82.6' width='123.6'
                radius='0.8'
                className="popup-container-lg"
            >
                <NewUserLayout currentScreen='user-basics'>
                    <ScreenTitle 
                        textSize="2" color="#111111" 
                        fontWeight="600"
                        bottomMargin="2.5"
                    >
                        Finishing up user role setup
                    </ScreenTitle>
                    <CustomContainer >
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            Assigned user settings
                        </AppSpan>
                        <CustomContainer topMargin="2.5">
                            <AppSpan 
                                textSize="1.6" color="#111111" 
                                fontWeight="700"
                            >
                                Display and username
                            </AppSpan>
                            <CustomContainer>
                                <FlexRow gap="1" topMargin="1" wrap="wrap">
                                    <AppSpan textSize="1.6" color="#4F4F4F">
                                        Display name:
                                    </AppSpan>
                                    <AppSpan textSize="1.6" color="#4F4F4F">
                                        {userCreationProcess?.firstName} {userCreationProcess?.lastName}
                                    </AppSpan>
                                </FlexRow>
                                {/* <FlexRow 
                                    gap="1" topMargin="1" 
                                    bottomMargin="1" wrap="wrap"
                                >
                                    <AppSpan textSize="1.6" color="#4F4F4F">
                                        Username:
                                    </AppSpan>
                                    <AppSpan textSize="1.6" color="#4F4F4F">
                                        {userCreationProcess?.username}
                                    </AppSpan>
                                </FlexRow> */}
                                {/* <AppSpan 
                                    textSize="1.6" 
                                    color="#111111" 
                                    fontWeight="700"
                                    hoverColor="#5627FF"
                                    cursor="pointer"
                                >
                                    Edit &gt;
                                </AppSpan> */}
                            </CustomContainer>
                        </CustomContainer>
                        <CustomContainer topMargin="2.5">
                            <AppSpan 
                                textSize="1.6" color="#111111" 
                                fontWeight="700"
                            >
                                Password
                            </AppSpan>
                            <CustomContainer>
                                <FlexRow gap="1" topMargin="1" wrap="wrap">
                                    <AppSpan textSize="1.6" color="#4F4F4F">
                                        Password details:
                                    </AppSpan>
                                    <FlexRow width="auto" sizeUnit="" gap="1">
                                        <AppSpan 
                                            textSize="1.6" color="#4F4F4F"
                                            topMargin={hidePassword ? '0.5' : '0'}
                                        >
                                            {hidePassword ? '***********' : userCreationProcess?.password}
                                        </AppSpan>
                                        { hidePassword ?
                                            <BsEye 
                                                fontSize='1.8rem'
                                                onClick={() => setHidePassword(!hidePassword)}
                                            />
                                            :
                                            <BsEyeSlash 
                                                fontSize='1.8rem' 
                                                onClick={() => setHidePassword(!hidePassword)}
                                            />
                                        }
                                    </FlexRow>
                                </FlexRow>
                                <FlexRow 
                                    gap="1" topMargin="1" 
                                    bottomMargin="1" wrap="wrap"
                                >
                                    <AppSpan textSize="1.6" color="#4F4F4F">
                                        Send to:
                                    </AppSpan>
                                    <AppSpan textSize="1.6" color="#4F4F4F">
                                        {userCreationProcess?.email}
                                    </AppSpan>
                                </FlexRow>
                                {/* <AppSpan 
                                    textSize="1.6" 
                                    color="#111111" 
                                    fontWeight="700"
                                    hoverColor="#5627FF"
                                    cursor="pointer"
                                >
                                    Edit &gt;
                                </AppSpan> */}
                            </CustomContainer>
                        </CustomContainer>
                        <CustomContainer topMargin="2.5">
                            <AppSpan 
                                textSize="1.6" color="#111111" 
                                fontWeight="700"
                            >
                                Admin Access
                            </AppSpan>
                            <CustomContainer>
                                { userCreationProcess?.roleType === 'SUPERADMIN' &&
                                    <AppText 
                                        textSize="1.6" 
                                        color="#4F4F4F" 
                                        topMargin="1"
                                    >
                                        Super Admin
                                    </AppText>
                                }
                                { userCreationProcess?.roleType != 'SUPERADMIN' &&
                                    <AppText 
                                        textSize="1.6" 
                                        color="#4F4F4F" 
                                        topMargin="1" 
                                    >
                                        Verification Access
                                    </AppText>
                                }
                                {/* <AppText 
                                    textSize="1.6" 
                                    color="#111111" 
                                    fontWeight="700"
                                    hoverColor="#5627FF"
                                    cursor="pointer"
                                    topMargin="1"
                                >
                                    Edit &gt;
                                </AppText> */}
                            </CustomContainer>
                        </CustomContainer>
                    </CustomContainer>
                    <FlexRow 
                        justifyContent="flex-end" 
                        topMargin="5" gap="1"
                    >
                        <Button 
                            width='15.4' 
                            hoverBgColor='#ffffff'
                            bgColor="#ffffff" 
                            hoverBorderColor='#5627FF'
                            hoverColor='#5627FF'
                            color="#5627FF"
                            onClick={back}
                        >
                            Back
                        </Button>
                        <Button 
                            width='15.4' 
                            hoverBgColor='#ffffff' 
                            hoverColor='#5627FF'
                            borderColor='#5627FF'
                            onClick={handleNext}
                        >
                            Finish Adding
                        </Button>
                    </FlexRow>
                </NewUserLayout>
            </FixedContainer>
        </>
    )
}